import {
    Accordion, AccordionDetails, AccordionSummary, Box, Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FAQ_ITEMS = [
    {
        q: 'איך הבוט מגיע גם למועמדים פאסיביים?',
        a: 'באמצעות וואטסאפ — הערוץ הכי פשוט ונגיש לכולם. המועמד לא צריך לעבור הרשמה מסובכת או לחפש באתרי דרושים; הוא מקבל משרות רלוונטיות, עונה על כמה שאלות קצרות, ורק אם יש התאמה ועניין — ממשיכים לשלב הבא.',
    },
    {
        q: 'כמה זמן לוקח עד שמקבלים מועמדים?',
        a: 'לאחר פרסום המשרה, המערכת מתחילה לאתר ולסנן מועמדים באופן מיידי.\nבדרך כלל ניתן להתחיל לראות מועמדים רלוונטיים תוך זמן קצר בהתאם לסוג המשרה, תחום העיסוק ורמת הביקוש בשוק.',
    },
    {
        q: 'איך מתחילים לפרסם משרה?',
        a: 'בוחרים חבילת משרות, משלימים הרשמה קצרה, ומתחילים לפרסם דרך ממשק המעסיקים.\nכך אפשר לנהל את המשרות, לעקוב אחרי מועמדים, ולבחור בהמשך חבילה שמתאימה לקצב הגיוס שלכם.',
    },
    {
        q: 'האם אפשר לבטל בכל עת?',
        a: 'כן. אין התחייבות ארוכת טווח.\nאפשר לבחור חבילה, לשדרג או לבטל — שיטה גמישה שמתאימה לקצב הגיוס שלכם.',
    },
    {
        q: 'איך נראות ההתאמות שאני מקבל/ת?',
        a: 'כל מועמד מוצג עם פרופיל מסודר, קו"ח, תגיות התאמה וציון התאמה חכם.\nכך ניתן להבין למה המועמד מתאים למשרה והאם כדאי להתקדם איתו לשיחה.',
    },
    {
        q: 'האם מתאים גם לעסקים קטנים?',
        a: 'כן. Mploy מתאים לעסקים קטנים כמו גם לחברות גדולות.\nהמטרה היא לאפשר לכלל גישה פשוטה ונגישה — גם בלי מחלקת גיוס גדולה.',
    },
];

const ElpFaq = (): JSX.Element => (
    <Box>
        <Box
            display="flex"
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={{ xs: 3, md: 6 }}
            alignItems="flex-start"
        >
            <Box flex={1} minWidth={0}>
                {FAQ_ITEMS.map(item => (
                    <Accordion
                        key={item.q}
                        disableGutters
                        elevation={0}
                        sx={{
                            borderBottom: '1px solid #f3f4f6',
                            '&:before': { display: 'none' },
                            '&.Mui-expanded': { margin: 0 },
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMore />} sx={{ padding: '0.5rem 0' }}>
                            <Typography fontWeight="bold" color="secondary">{item.q}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: '0 0 1rem' }}>
                            <Typography color="secondary" variant="body2" style={{ whiteSpace: 'pre-line' }}>
                                {item.a}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
            <Box
                component="img"
                src="/images/elp-landing-page.png"
                alt="איור"
                sx={{
                    display: { xs: 'none', md: 'block' },
                    flex: '0 0 38%',
                    width: '38%',
                    height: 'auto',
                    objectFit: 'contain',
                    alignSelf: 'center',
                }}
            />
        </Box>
    </Box>
);

export default ElpFaq;
